import axios from "axios";
import { createContext, use, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DashboardContext } from "../dashboard/DashboardContext";
import { BaseUrlContext } from "../context/BaseUrlContext";

export const ChangePasswordContext = createContext();

export const ChangePasswordProvider = ({ children }) => {
  const { BaseUrl } =useContext(BaseUrlContext);
  const { userData,tokenKey } =useContext(DashboardContext);
  const navigate = useNavigate();
  const [error, setError] = useState("");

  // ----------------- STATE -----------------
  const initialFormData = {
    
    userName: userData?.userName,
    newPassword: "",
    confirmPassword: ""
  
  }
  const [formData, setFormData] = useState(initialFormData);

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
useEffect(() => {
  if (userData?.userName) {
    setFormData(prevData => ({
      ...prevData,
      userName: userData?.userName
    }));
  }
}, [showChangePasswordModal]); // <--- depend on userData

  // ----------------- MODAL HANDLERS -----------------
  const handleOpenChangePassword = () => setShowChangePasswordModal(true);
  const handleCloseChangePassword = () => setShowChangePasswordModal(false);

  // ----------------- FORM HANDLER -----------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
     if (e.target.value.length > 20) {
      setError("Password can only contain 20 characters!");
    } else {
      setError("");
    }
  };
//---------------------RESET PAGE-----------------------
const ResetForm = () => {
  setFormData({
    userName: JSON.parse(localStorage.getItem("username")) || "",
    newPassword: "",
    confirmPassword: ""
  });
};
  // ----------------- UPDATE PASSWORD -----------------
  const handleUpdate = async (userName, newPassword) => {
    if (!newPassword || !formData.confirmPassword) {
      toast.error("All fields are required!", { position: "top-center" });
      return;
    }

    if (newPassword !== formData.confirmPassword) {
      toast.error("New password and confirm password do not match!", { position: "top-center" });
      return;
    }

    try {
      const res = await axios.put(
        `${BaseUrl}user/change-password/${userName}`,
        {
          newPassword,
          confirmPassword: formData.confirmPassword
        },{ headers: { Authorization: `Bearer ${tokenKey}` } }
      );

      if (
        res.data.includes("incorrect") ||
        res.data.includes("not match") ||
        res.data.includes("not found")
      ) {
        toast.error(res.data, { position: "top-center" });
      } else {
        toast.success(res.data, { position: "top-center" });

        setFormData({
          ...formData,
          newPassword: "",
          confirmPassword: ""
        });
        handleCloseChangePassword();
      }
    } catch (err) {
      toast.error(err.response?.data || "Error updating password", { position: "top-center" });
    }
  };

  // ----------------- LOGOUT -----------------
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <ChangePasswordContext.Provider
      value={{
        formData,
        error,
        setFormData,
        setError,
        showChangePasswordModal,
        handleOpenChangePassword,
        handleCloseChangePassword,
        handleChange,
        handleUpdate,
        handleLogout,
        ResetForm
      }}
    >
      {children}
    </ChangePasswordContext.Provider>
  );
};
